import { FC } from "react";
import { faMap } from "@fortawesome/free-regular-svg-icons";
import orderOptimizerTranslationsHelper from "../../../../../../languages/order-optimizer-translations.helper";
import LinkButtonComponent from "../../../../../../common/components/button/link/link-button.component";
import TableLinkButtonComponent from "../../../../../../common/components/table/button/link/table-link-button.component";
import OrderOptimizerDetailsTableDotComponent from "../../../../common/dot/order-optimizer-details-orders-table-dot.component";
import OrderOptimizerCargoDetailsItem, {
  OrderOptimizerCargoDetailsItemStepsOrdersPoints,
} from "../../common/types/order-optimizer-cargo-details-item";
import orderOptimizerCargoDetailsHelper from "../../order-optimizer-cargo-details.helper";

type OrderOptimizerCargoDetailsHiddenDetailsSummaryFooterProps = {
  detailsItem: OrderOptimizerCargoDetailsItem;
  isABA?: boolean;
};

const OrderOptimizerCargoDetailsHiddenDetailsSummaryFooterComponent: FC<
  OrderOptimizerCargoDetailsHiddenDetailsSummaryFooterProps
> = (props) => {
  const translations =
    orderOptimizerTranslationsHelper.getCargoDetailsTranslations().table
      .lowerSection;

  const dotColor = "#d9d9d9";

  const index = 0;

  const detailsStepsOrderPoints: OrderOptimizerCargoDetailsItemStepsOrdersPoints[] =
    props.detailsItem.steps.orders.map((order) => order.points).flat();
  const detailsStepsOrderLastRoute: OrderOptimizerCargoDetailsItemStepsOrdersPoints[] =
    props.detailsItem.steps.orders[props.detailsItem.steps.orders.length - 1]
      .points;
  const detailsStepsOrderLastPoint: OrderOptimizerCargoDetailsItemStepsOrdersPoints[] =
    [detailsStepsOrderLastRoute[detailsStepsOrderLastRoute.length - 1]];

  return (
    <>
      <div className="order_optimizer_cargo_details_hidden_details__lower_section__footer">
        <h4 className="order_optimizer_cargo_details_hidden_details__lower_section__footer__driver" />
        <div className="order_optimizer_cargo_details_hidden_details__lower_section__footer__order">
          <div className="order_optimizer_cargo_details_hidden_details__lower_section__footer__order__human_id">
            {props.isABA ? (
              <>
                <span
                  className="order_optimizer_cargo_details_hidden_details__lower_section__footer__order__human_id__text"
                  title={String(index)}
                >
                  {index}
                </span>
                <OrderOptimizerDetailsTableDotComponent color={dotColor} />
              </>
            ) : (
              <>---</>
            )}
          </div>
          {props.isABA ? (
            <div className="order_optimizer_cargo_details_hidden_details__lower_section__footer__order__text">
              {props.detailsItem.steps.lastPoint?.displayName}
            </div>
          ) : (
            <div className="order_optimizer_cargo_details_hidden_details__lower_section__footer__order__text">
              <div className="order_optimizer_cargo_details_hidden_details__lower_section__footer__order__text__dotted_address">
                ---
              </div>
              <div className="order_optimizer_cargo_details_hidden_details__lower_section__footer__order__text__dotted_text">
                ---
              </div>
              <div className="order_optimizer_cargo_details_hidden_details__lower_section__footer__order__text__dotted_text">
                ---
              </div>
            </div>
          )}
          <div className="button_full_route">
            {props.isABA ? (
              <LinkButtonComponent
                to={orderOptimizerCargoDetailsHelper.getGoogleMapsUrl(
                  detailsStepsOrderPoints,
                  props.detailsItem.steps.lastPoint?.lat,
                  props.detailsItem.steps.lastPoint?.lon,
                  true
                )}
                title={translations.routeButtonTitle}
                type="primary"
                openInNewTab
              >
                {translations.routeButtonLabel}
              </LinkButtonComponent>
            ) : (
              <>---</>
            )}
          </div>
          <div className="button_route">
            {props.isABA && (
              <TableLinkButtonComponent
                icon={faMap}
                openInNewTab
                to={orderOptimizerCargoDetailsHelper.getGoogleMapsUrl(
                  detailsStepsOrderLastPoint,
                  props.detailsItem.steps.lastPoint?.lat,
                  props.detailsItem.steps.lastPoint?.lon,
                  true
                )}
                type="primary"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderOptimizerCargoDetailsHiddenDetailsSummaryFooterComponent;
